const contactLines = ["Near Mlimani City", "Dar Es Salaam", "Tanzania"];

export default function ContactUsContent() {
  return (
    <>
      <section className="vex-page-hero" data-aos="fade-up">
        <div className="container">
          <div className="vex-page-hero-shell" data-aos="fade-up">
            <p className="vex-eyebrow">Contact VEX</p>
            <h1>
              Speak with a team that can support your next supply and
              distribution requirement.
            </h1>
            <p>
              Reach out for procurement support, category inquiries, and supply
              coordination across our public health, hygiene, office, and
              general trading solutions.
            </p>
          </div>
        </div>
      </section>

      <section className="vex-section vex-section-light" data-aos="fade-up">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-6" data-aos="fade-right">
              <div className="vex-contact-card vex-contact-card-main">
                <p className="vex-panel-tag">Office Location</p>
                <div className="vex-address-stack">
                  {contactLines.map((line) => (
                    <p key={line}>{line}</p>
                  ))}
                </div>
                <p>
                  Our Dar Es Salaam team is ready to support procurement,
                  category inquiries, and supply coordination for your business
                  or institution.
                </p>
              </div>
            </div>

            <div className="col-lg-6" data-aos="fade-left">
              <div className="vex-contact-card vex-contact-card-dark">
                <p className="vex-panel-tag vex-panel-tag-light">Contact</p>
                <a href="tel:+255767105804">Tel: +255 767 105 804</a>
                <a href="mailto:supply@vex-traders.co.tz">
                  E-mail: supply@vex-traders.co.tz
                </a>
                <p>
                  Reach out for category-based supply support, recurring
                  sourcing, and professional follow-up on operational
                  procurement needs.
                </p>
              </div>
            </div>
          </div>

          <div className="vex-contact-ribbon">
            <div
              className="vex-contact-ribbon-card"
              data-aos="fade-up"
              data-aos-delay="50"
            >
              <span>Location</span>
              <strong>Near Mlimani City, Dar Es Salaam</strong>
            </div>
            <div
              className="vex-contact-ribbon-card"
              data-aos="fade-up"
              data-aos-delay="120"
            >
              <span>Coverage</span>
              <strong>
                Public, corporate, and institutional supply support
              </strong>
            </div>
            <div
              className="vex-contact-ribbon-card"
              data-aos="fade-up"
              data-aos-delay="190"
            >
              <span>Response</span>
              <strong>Professional coordination with prompt follow-up</strong>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
